<template>
    <header id="header">
        <div class="left-part"></div>
        <a id="logo" href="index.html"><img src="../../static/img/synthesizer.png" class="img-logo" /></a>
        <!-- check test -->
        <!-- <div class="bar-holder">
            <a class="menu_trigger" href="javascript:void(0)" v-on:click="showmenu"></a>
            <nav id="nav">
                <ul>
                    <li><a href="about.html">Giới thiệu</a></li>
                    <li><a href="index.html">Liên hệ</a></li>
                </ul>
            </nav>
        </div> -->
    </header>
</template>

<script>
export default {
    name: 'Header',
    data: function(){
        return{
            showMenu: false
        }
    },
    created (){
        document.title = 'Dạy Organ Minh Trí'
    },
    methods:{
        showmenu: function(){
            if(this.showMenu == false){
                document.getElementById('nav').style.display='block'
                this.showMenu=true
            }
            else{
                document.getElementById('nav').style.display='none'
                this.showMenu=false
            }
            
        }
    }
}
</script>

<style scoped>
.img-logo{
    width: 50px;
    height: 50px;
}
</style>